var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNewsletterActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4151 12.5875L25.5557 13.556C25.0173 13.7384 24.433 13.4497 24.2506 12.9113C24.0683 12.3729 24.3569 11.7887 24.8953 11.6063L28.321 10.446C29.5755 10.0211 30.8178 11.1178 30.5518 12.4153L27.2128 28.7006C26.9589 29.9391 25.4981 30.4868 24.4926 29.7205L19.9282 26.242L17.4584 28.2496C16.5785 28.9649 15.2591 28.6449 14.8047 27.606L12.3097 21.9015L9.90733 21.0878C8.40845 20.5802 8.3379 18.4865 9.79919 17.8791L19.5126 13.8413C20.0375 13.6231 20.6399 13.8717 20.8581 14.3966C21.0763 14.9215 20.8276 15.5239 20.3027 15.7421L11.4303 19.4303L13.1136 20.0004C13.5707 20.1553 13.9415 20.4955 14.1349 20.9378L16.51 26.3678L18.8393 24.4743C19.454 23.9746 20.331 23.9608 20.9611 24.441L25.306 27.7522L28.4151 12.5875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1885 17.0668C25.6481 17.1817 25.9275 17.6474 25.8126 18.107L24.4403 23.5963C24.3254 24.0559 23.8597 24.3353 23.4001 24.2204C22.9406 24.1055 22.6612 23.6398 22.7761 23.1803L24.1484 17.6909C24.2633 17.2313 24.729 16.9519 25.1885 17.0668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNewsletterActive);
export default __webpack_public_path__ + "static/media/ic_newsletter_active.6600a8e2c5f3631df3fb9c350dbaa929.svg";
export { ForwardRef as ReactComponent };